import { render, staticRenderFns } from "./launch-header-v2.vue?vue&type=template&id=2892cd81&"
import script from "./launch-header-v2.vue?vue&type=script&lang=ts&"
export * from "./launch-header-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports